import React, { FC } from 'react';
import { SearchResultCommentarySubtitle } from './SearchResultCommentarySubtitle';
import { SearchCommentary } from './searchResultComment.types';
import styles from './search_result_commentary.module.scss';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { CommentarySummary } from '../../../../commentary/components/summary/CommentarySummary';
import { CommentaryTitle } from '../../../../commentary/components/title/CommentaryTitle';
import { SearchResultCommentarySources } from './SearchResultCommentarySources';

type Props = {
  commentary: SearchCommentary;
  originalQueryKey: string;
  enableSnippets?: boolean;
};

export const SearchResultCommentary: FC<Props> = ({
  commentary,
  originalQueryKey,
  enableSnippets = false,
}) => {
  const source = 'excerpt_results_comment';

  const sendTrackingEvent = () => {
    doctrineAnalytics('Search ResultClicked', {
      type: 'comment',
      position: commentary.position,
      commentaire_id: commentary.commentaireId,
      url: commentary.url,
      original_query_key: originalQueryKey,
    });
  };

  const hasSources =
    (commentary.linkedDecisions && commentary.linkedDecisions.total > 0) ||
    (commentary.linkedLegislationArticles &&
      commentary.linkedLegislationArticles.total > 0);

  return (
    <>
      <div className={styles.wrapper}>
        <CommentaryTitle
          position={commentary.position}
          onClick={sendTrackingEvent}
          dataTestId="search-comment-title-link"
          commentary={commentary}
          source={source}
        />
        <SearchResultCommentarySubtitle comment={commentary} />
        {Boolean(commentary.textShort) && (
          <CommentarySummary
            source={source}
            commentary={commentary}
            onClick={sendTrackingEvent}
            position={commentary.position}
          />
        )}
      </div>
      {enableSnippets && hasSources && (
        <SearchResultCommentarySources
          commentary={commentary}
          source={source}
        />
      )}
    </>
  );
};
